import script from "./UploadFilePDFReplace.vue?vue&type=script&lang=ts&setup=true"
export * from "./UploadFilePDFReplace.vue?vue&type=script&lang=ts&setup=true"

import "./UploadFilePDFReplace.vue?vue&type=style&index=0&id=89b456ec&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-89b456ec"]])

export default __exports__